import { useState } from 'react';

type ReturnValue = {
  /** 開閉状態。 */
  isOpen: boolean;
  /** 開く関数。 */
  handleOpen: VoidFunction;
  /** 閉じる関数。 */
  handleClose: VoidFunction;
};

/** 開閉状態を管理するカスタムフック。 */
export const useOpenClose = (): ReturnValue => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return { isOpen, handleOpen, handleClose };
};
